
namespace TabAurous.Stock {
    import fld = StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class SupplierPerformance extends Serenity.EntityGrid<StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.SupplierPerformance'; } 
        protected getIdProperty() { return StockItemRow.idProperty; }
        protected getInsertPermission() { return StockItemRow.insertPermission; }
        protected getLocalTextPrefix() { return StockItemRow.localTextPrefix; }
        protected getService() { return SupplierPerformanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("VoucherDate", "Date");
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setGrouping([{
                getter: 'LedgerName',
                displayTotalsRow: false,
            },{
                getter: 'ProductTypeName',
                displayTotalsRow: false,
            },{
                getter: 'CategoryName',
                displayTotalsRow: false,
            }]);
            return grid;
        }
       
      
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: 'Stock.StoneRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            }
            );
            return buttons;
        }
    }
}